/**
 * Feedbacks enviados pelo aplicativo móvel.
 *
 * Espelha `FeedbackResponseDTO` do core (branch `main`):
 * `core/src/main/java/.../adapter/in/restfull/dto/response/FeedbackResponseDTO.java`.
 *
 * O DTO usa `@JsonInclude(NON_NULL)`, então todo campo nulo vem ausente do JSON —
 * daí praticamente tudo ser opcional aqui.
 */

/** Campo `type` do backend. Gravado em maiúsculas, com `SUGESTAO` como padrão. */
export type FeedbackType = "MELHORIA" | "ERRO" | "SUGESTAO";

/**
 * O que a tela chama de "Categoria".
 *
 * Atenção: no backend isso é o campo `type`, não o campo `category`. Não há
 * endpoint que filtre por `type` — o filtro é aplicado no cliente.
 */
export const FEEDBACK_TYPES: { label: string; value: FeedbackType }[] = [
  { label: "Melhoria", value: "MELHORIA" },
  { label: "Erro", value: "ERRO" },
  { label: "Sugestão", value: "SUGESTAO" },
];

/** Enum `FeedbackStatus` do core. */
export type FeedbackStatus = "OPEN" | "IN_REVIEW" | "RESOLVED" | "ARCHIVED";

export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  OPEN: "Aberto",
  IN_REVIEW: "Em análise",
  RESOLVED: "Resolvido",
  ARCHIVED: "Arquivado",
};

export interface Feedback {
  id: string;
  /** Elo com o log do backend no Kibana. */
  traceId?: string;

  userId?: string;
  userEmail?: string;
  userName?: string;

  type?: string;
  /** Assunto. `title` carrega o mesmo valor. */
  subject?: string;
  title?: string;
  /** A mensagem do usuário. O backend normaliza `message`/`description`/`comment` aqui. */
  description?: string;

  /**
   * String livre. O app grava o módulo de origem (`profile`, `payment`...),
   * NÃO os valores de Melhoria/Erro/Sugestão.
   */
  category?: string;
  module?: string;
  /** Nota de 1 a 5. Ausente quando o usuário não avalia. */
  rating?: number;
  /** Código do posto. O app não envia hoje — ver o README da tela. */
  stationCode?: string;
  orderId?: string;
  deviceInfo?: string;
  attachmentUrl?: string;
  attachments?: string[];

  appVersion?: string;
  buildNumber?: string;
  platform?: string;
  osVersion?: string;
  deviceModel?: string;
  screen?: string;
  sessionId?: string;

  /** Objetos crus enviados pelo React Native, guardados como mapa livre. */
  app?: Record<string, unknown>;
  device?: Record<string, unknown>;
  context?: Record<string, unknown>;

  status?: FeedbackStatus;
  adminNotes?: string;
  resolvedAt?: string;
  resolvedBy?: string;

  /** Formato `yyyy-MM-dd'T'HH:mm:ss`, sem timezone. */
  createdAt?: string;
}
